import React from 'react';
import PropTypes from 'prop-types';

const CroppingBottomNav = (props) => {
  const {
    count,
    total,
    changeDomain,
    domain,
    changeTimeRange,
    timeRange,
  } = props;

  let summary = '';

  if (count && total) {
    summary = <p className="dib mll">{`Showing ${count} of ${total}`}</p>;
  }

  return (
    <div className="mtm">
      <p className="dib mll mrs">Domain: </p>
      <select className="dib" onChange={changeDomain} value={domain}>
        <option value="All">All</option>
        <option value="otrapuse.lv">otrapuse.lv</option>
        <option value="lindoamor.ee">lindoamor.ee</option>
        <option value="tavomeile.lt">tavomeile.lt</option>
        <option value="lindoamor.com">lindoamor.com</option>
      </select>
      <p className="dib mll mrs">Time range: </p>
      <select className="dib" onChange={changeTimeRange} value={timeRange}>
        <option value="1-week">1 week</option>
        <option value="1-month">1 month</option>
        <option value="1-year">1 year</option>
        <option value="All">All</option>
      </select>
      {summary}
    </div>
  );
};

CroppingBottomNav.propTypes = {
  changeDomain: PropTypes.func.isRequired,
  domain: PropTypes.string.isRequired,
  changeTimeRange: PropTypes.func.isRequired,
  timeRange: PropTypes.string.isRequired,
  count: PropTypes.number,
  total: PropTypes.number,
};

CroppingBottomNav.defaultProps = {
  count: 0,
  total: 0,
};

export default CroppingBottomNav;
